import constants from "@/config/config.js";
import FilePdf from "vue-material-design-icons/FilePdf.vue";
import MoneySign from "../Money.vue";

export default {
  components: {
    "file-pdf-icon": FilePdf,
    "money-sign": MoneySign
  },
  data() {
    return {
      recibosCobranza: null,
      pages: 1,
      currentPage: 1,
      items: [],
      fields: [
        { key: "socio" },
        { key: "unidad", label: "Unidad" },
        {
          key: "deduccionesPagadas",
          label: "Deducciones Pagadas"
        },
        { key: "montoTotal", label: "Monto Total" },
        { key: "fechaCreacion", label: "Fecha de creación" },
        { key: "accion", label: "Acción" }
      ],
      entradas: [10, 20, 30],
      entrada: null,
      selected: false,
      isBusy: false,
      isEmpty: false,
      isDisabled: false,
      rows: 1
    };
  },
  // Antes de que se cree el componente, se ejecuta el método de obtener cobranza unidades
  mounted() {
    this.getRecibosCobranza();
    this.entrada = this.entradas[0].toString();
  },
  computed: {
    perPage: {
      get: function() {
        if (this.selected) {
          return this.entrada;
        } else {
          return (this.entrada = "10");
        }
      },
      set: function() {
        if (this.selected) {
          return this.entrada;
        } else {
          return (this.entrada = "10");
        }
      }
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.items = [];
        this.getRecibosCobranza();
      }
    },
    selected: {
      handler: function() {
        this.perPage = this.entrada;
        this.items = [];
        this.getRecibosCobranza();
      }
    }
  },
  methods: {
    async getRecibosCobranza() {
      // Mostrar mensaje de cargando en la página si es que no se muestran los datos aún en la tabla
      this.isBusy = true;
      this.isDisabled = true;
      const { status, data } = await this.Api.get(
        `cobranza/recibos?perPage=${this.perPage}&page=${this.currentPage}`
      );
      if (status) {
        this.rows = data.total;
        this.recibosCobranza = data.data;
        this.recibosCobranza.sort(this.orderArrayOfObjects("economico"));
        this.recibosCobranza.forEach(recibo => {
          const socio = `${recibo.socioNombre}  ${recibo.socioApellidoPaterno}`;
          let isNull = false;
          if (recibo.rutaPDF === null) {
            isNull = true;
          }
          recibo = {
            socio: socio,
            unidad: recibo.unidad,
            deduccionesPagadas: recibo.cantidadDeduccionesPagadas,
            montoTotal: recibo.montoTotal,
            fechaCreacion: recibo.fechaCreacion,
            accion: {
              value: `${constants.apiEndPoint}${recibo.rutaPDF}`,
              isNull
            }
          };
          this.items.push(recibo);
        });
        if (this.items.length === 0) {
          this.isEmpty = true;
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }
      this.isBusy = false;
    },
    showText(entrada) {
      if (this.selected) {
        this.items = [];
        this.perPage = entrada;
        this.entrada = entrada;
        this.getRecibosCobranza();
      }
      return (this.entrada = entrada.toString());
    },
    // Abre una nueva ventana con la ruta que se le pase
    // En este caso se utiliza para los botones que muestran los PDF de cobranza
    sendTo(ruta) {
      window.open(ruta);
    },
    orderArrayOfObjects(key, order = "asc") {
      return function innerSort(a, b) {
        if (
          !Object.prototype.hasOwnProperty.call(a, key) ||
          !Object.prototype.hasOwnProperty.call(b, key)
        ) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    }
  }
};
